import { DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDuplicateControlSlideout extends Layout {
    labelAction: Label;
    labelExclude: Label;
    labelGOrder: Label;
    labelOriginatingOrder: Label;
    labelContainer: Label;
    labelL: Label;
    labelM: Label;
    labelP: Label;
    panelActions: Panel;
    panelExclude: Panel;
    panelNew: Panel;
    panelOrig: Panel;
    panelContainer: Panel;
    panelContainerOrder: Panel;
    panelExciseTax: Panel;
    panelHandling: Panel;
    panelLtl: Panel;
    panelMulticurrency: Panel;
    panelOrderLength: Panel;
    panelPartialShipment: Panel;
    panelSpacerMulticurrency: Panel;
    panelSpacerPS: Panel;
    panelSwitches1: Panel;
    panelSwitches2: Panel;
    sourceCopyControl: DataSource;
    switchAllocation: Switch;
    switchBillDistance: Switch;
    switchBillOfLading: Switch;
    switchBrkQualProfile: Switch;
    switchC: Switch;
    switchClearFreight: Switch;
    switchClearOther: Switch;
    switchClearOvrPay: Switch;
    switchClearExciseTaxes: Switch;
    switchComments: Switch;
    switchConsigneeRef: Switch;
    switchContainerOrder: Switch;
    switchDeliveredOrders: Switch;
    switchDriverLoadUnload: Switch;
    switchEdiStatus: Switch;
    switchEquipMatchDetail: Switch;
    switchExciseTax: Switch;
    switchFreightItems: Switch;
    switchHandlingRequirement: Switch;
    switchLockMiles: Switch;
    switchOrderLength: Switch;
    switchOrderType: Switch;
    switchOrderValue: Switch;
    switchOtherCharges: Switch;
    switchRate: Switch;
    switchReferenceNumbers: Switch;
    switchRevenue: Switch;
    switchRouteType: Switch;
    switchStops: Switch;
    switchWeight: Switch;
    switchYSplits: Switch;
    textboxBillTo: Textbox;
    textboxCCtrlParty: Textbox;
    textboxCopyBillTo: Textbox;
    textboxCopyOvrdPayee: Textbox;
    textboxCopyRevenueId: Textbox;
    textboxCopyStatus: Textbox;
    textboxCopyTo: Textbox;
    textboxCopyType: Textbox;
    textboxDates: Textbox;
    textboxDescription: Textbox;
    textboxOrigCtrlParty: Textbox;
    textboxOrigOvrPayee: Textbox;
    textboxOrigRevCode: Textbox;
    textboxOrigStatus: Textbox;
}
